module.exports = __webpack_public_path__ + "public-ui/fonts/greek.be8e775e.woff2";